import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { SseService } from './sse.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AiservicesService {
  constructor(private _zone: NgZone, private _sseService: SseService, private http: HttpClient) { }

  getMaxOilTime(deviceid) {
    return this.http.post(`getMaxOilTime`,deviceid);
  }
}
